/* eslint-disable import/no-default-export */
/* eslint-disable @trello/export-matches-filename */
import React, { Suspense, lazy } from 'react';
import classnames from 'classnames';

import Spinner from 'app/common/components/loading/spinner';
import Auth from 'app/scripts/db/auth.coffee';
import { HomeLeftSidebarContainer } from 'app/scripts/views/home/presentational/HomeLeftSidebarContainer.js';

// eslint-disable-next-line @trello/less-matches-component,@trello/assets-alongside-implementation
import orientationCardStyles from 'app/scripts/views/home/presentational/orientation-card.less';
import styles from './TeamReportPage.less';

const TeamReportContainer = lazy(() =>
  import(/* webpackChunkName: "team-report-container" */ './TeamReportContainer'),
);

export interface TeamReportsContainerProps {
  teamName: string;
  teamDisplayName: string;
  modelCache: {
    get: (modelType: string, modelId: string) => object;
  };
}

export const TeamReportPage: React.FunctionComponent<
  TeamReportsContainerProps
> = ({ teamName, teamDisplayName, modelCache }) => {
  return (
    <div className={classnames(['home-container', styles.teamReportsPage])}>
      <div className="home-sticky-container">
        <div className={styles.leftNav}>
          <HomeLeftSidebarContainer
            orgname={teamName}
            modelCache={modelCache}
            model={modelCache.get('Member', Auth.me().id)}
            allBoards={false}
            orgBoards={() => null}
            orgCards={undefined}
          />
        </div>
        <div
          className={classnames([
            'home-main-content-container',
            styles.contentContainer,
          ])}
        >
          <div
            className={classnames([
              orientationCardStyles.orientationCard,
              styles.orientationCard,
            ])}
          >
            <Suspense
              fallback={<Spinner centered wrapperClassName={styles.loading} />}
            >
              <TeamReportContainer
                teamName={teamName}
                teamDisplayName={teamDisplayName}
              />
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};
